class InteractiveAccordions {
  constructor(section) {
    this.section = section;
    this.accordionItems = section.querySelectorAll(
      '.interactive-accordion-item',
    );
    this.accordionHeaders = section.querySelectorAll(
      '.interactive-accordion-header',
    );
    this.accordionContents = section.querySelectorAll(
      '.interactive-accordion-content',
    );
    this.sectionBackgroundImages = section.querySelectorAll(
      '.section-background-image',
    );
    this.isMobile = window.innerWidth < 768;
    this.activeAccordionIndex = 0; // Track the currently active accordion

    this.init();
    this.setupResizeListener();
  }

  init() {
    if (!this.isMobile) {
      this.initDesktop();
    }
  }

  setupResizeListener() {
    // Handle resize events to reinitialize desktop functionality if needed
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 768;

      // Only reinitialize if we've crossed the breakpoint
      if (wasMobile !== this.isMobile && !this.isMobile) {
        this.initDesktop();
      }
    });
  }

  initDesktop() {
    // Initialize desktop accordions
    this.accordionHeaders.forEach((header, index) => {
      header.addEventListener('click', () => {
        this.toggleAccordion(index);
      });
    });

    // Set first accordion as active by default
    if (this.accordionItems.length > 0) {
      const firstContent = this.accordionContents[0];
      if (firstContent) {
        firstContent.style.maxHeight = `${firstContent.scrollHeight}px`;
      }
      this.activeAccordionIndex = 0;
    }
  }

  toggleAccordion(index) {
    const item = this.accordionItems[index];
    const content = this.accordionContents[index];
    const isActive = item.classList.contains('t-active');

    // Close all accordions
    this.accordionItems.forEach((accordionItem) => {
      accordionItem.classList.remove('t-active');
    });

    this.accordionContents.forEach((accordionContent) => {
      accordionContent.classList.remove('t-active');
      accordionContent.style.maxHeight = null;
    });

    // Hide all background images
    this.sectionBackgroundImages.forEach((image) => {
      image.classList.remove('t-opacity-100');
      image.classList.add('t-opacity-0');
    });

    // If the clicked item wasn't active, open it
    if (!isActive) {
      item.classList.add('t-active');
      content.classList.add('t-active');
      content.style.maxHeight = `${content.scrollHeight}px`;

      // Find and show the corresponding background image
      const itemId = item.getAttribute('data-accordion-item');
      const backgroundImage = this.section.querySelector(
        `.section-background-image[data-background-id="${itemId}"]`,
      );

      if (backgroundImage) {
        backgroundImage.classList.remove('t-opacity-0');
        backgroundImage.classList.add('t-opacity-100');
      }
      
      // Update active index
      this.activeAccordionIndex = index;
    } else {
      // If we're closing the active accordion, reopen the first one
      this.accordionItems[0].classList.add('t-active');
      this.accordionContents[0].classList.add('t-active');
      this.accordionContents[0].style.maxHeight = `${this.accordionContents[0].scrollHeight}px`;

      if (this.sectionBackgroundImages.length > 0) {
        this.sectionBackgroundImages[0].classList.remove('t-opacity-0');
        this.sectionBackgroundImages[0].classList.add('t-opacity-100');
      }
      
      // Reset active index to first accordion
      this.activeAccordionIndex = 0;
    }
  }
}

// Initialize all interactive accordions on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.interactive-accordions');
  sections.forEach((section) => {
    new InteractiveAccordions(section.closest('.t-relative.t-overflow-hidden'));
  });
}); 